export function pushOrCreate (collection, key, ...values) {
  let result = collection[key]
  if (result == null) {
    result = [...values]
    collection[key] = result
    return result
  }

  result.push(...values)
  return result
}

export default {
  pushOrCreate
}
